var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0C6.2733 0 0 6.2733 0 14C0 21.7267 6.2733 28 14 28C21.7267 28 28 21.7267 28 14C28 6.2733 21.7267 0 14 0ZM14 1.95349C20.6484 1.95349 26.0465 7.35163 26.0465 14C26.0465 20.6484 20.6484 26.0465 14 26.0465C7.35163 26.0465 1.95349 20.6484 1.95349 14C1.95349 7.35163 7.35163 1.95349 14 1.95349Z",
    fill: "#F59E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIcon2);
export default __webpack_public_path__ + "static/media/DefaultIcon2.bb57cd2ae0a295a12c4f5222fed20794.svg";
export { ForwardRef as ReactComponent };